import { StartChatInitialData } from '@wix/wix-chatbot-common/browser';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { ACTIONS } from '../../constants';
import { IRootResetChatbotState } from '../reducers/types';
import { useRequestOriginParams } from './useRequestOriginParams';

export const useResetChatbotState = () => {
  const requestOriginParams = useRequestOriginParams();
  const dispatch = useDispatch();

  return useCallback(
    (state: StartChatInitialData) => {
      dispatch<IRootResetChatbotState>({
        type: ACTIONS.RESET_CHATBOT_STATE,
        initialChatbotState: state,
      });

      configureSentryScope(state.chat.conversationId);
      void requestOriginParams();
    },
    [dispatch, requestOriginParams],
  );
};

function configureSentryScope(conversationId: string): void {
  try {
    window.Sentry.configureScope((scope) => {
      scope.setExtra('sessionId', conversationId);
    });
  } catch (err) {
    console.error(err);
  }
}
